import { callService } from "../../services/services";
import { getErrorMessage } from "../../utils/enums";
import { updateAlert } from "../alert/actions";
import { addProcessContext } from "../processContext/actions";
import { updateLimitAndPaymentInfo } from "./actions";

export const getProductInfo = (body, returnOnlyResponse) => {
  return async (dispatch) => {
    return await callService("productInfo", body, dispatch, body.externalId)
      .then((response) => {
        const data = response.data;
        if(data?.resultCode === "4007134") {
          return data;
        } 
        if (data.result === "1") {
          if (returnOnlyResponse) {
            return data;
          }
          dispatch(updateLimitAndPaymentInfo(data));
          return true;
        } else {
          throw data;
        }
      })
      .catch((err) => {
        let errText = "";
        if (err.errorExplanation) {
          errText = err.errorExplanation;
        } else if (err.errorText) {
          errText = err.errorText;
        }
        dispatch(
          updateAlert({
            severity: "error",
            text: errText,
            open: true,
          })
        );
      });
  };
};

export const getInterestRate = (body) => {
  return async (dispatch) => {
    return await callService("getInterestRate", body, dispatch, body.externalId)
      .then((response) => {
        const data = response.data;
        if (data.result === "1") {
          data.interestList = data.interestList
            .filter((row) => parseFloat(row.usableAmount) > 0)
            .sort(
              (firstRow, secondRow) =>
                Number(firstRow.installmentNumber) -
                Number(secondRow.installmentNumber)
            )
            .map((row, id) => {
            return {
              id,
              insuranceSelection:
                row?.insuranceFlag === "1" || row?.insuranceFlag === "2"
                  ? "Evet"
                  : row?.insuranceFlag === "3"
                  ? "Seçiniz"
                  : "Hayır",
              ...row,
            };
          });
          // approved but limit type not set yet -> every row comes back with usableAmount 0
          if (data.interestList.length === 0) {
            dispatch(
              updateAlert({
                severity: "error",
                text: getErrorMessage("MS0034") || "Kullanılabilir limitiniz bulunmamaktadır.",
                open: true,
              })
            );
            return false;
          }
          dispatch(
            updateLimitAndPaymentInfo({ interestList: data.interestList })
          );
          return true;
        } else {
          throw data;
        }
      })
      .catch((err) => {
        let errText = "";
        if (err.errorExplanation) {
          errText = err.errorExplanation;
        } else if (err.errorText) {
          errText = err.errorText;
        }

        dispatch(
          updateAlert({
            severity: "error",
            text: errText,
            open: true,
          })
        );
      });
  };
};

export const getSimulation = (body) => {
  return async (dispatch) => {
    return await callService("getSimulation", body, dispatch, body.externalId)
      .then((response) => {
        const data = response.data;
        if (data.result === "1") {
          if (data.paymentPlan) {
            data.simulationCreated = true;
            data.paymentPlan = data.paymentPlan?.map((row, id) => {
              return {
                id,
                ...row,
              };
            });

            dispatch(updateLimitAndPaymentInfo({paymentPlanData:data}));
            dispatch(
              addProcessContext({
                paymentPlan: data.paymentPlan,
                refundAmount: data.refundAmount,
                sumCreditAmount: data.sumCreditAmount,
                remainingInsuranceAmount:data.remainingInsuranceAmount,
                showInsuranceFlag:data.showInsuranceFlag,
                limitAllocationCommAmount: data.limitAllocationCommAmount,
              })
            );
            return true;
          } else {
            throw data.errorExplanation || getErrorMessage("MS0035");
          }
        } else {
          throw data.errorExplanation || getErrorMessage("MS0035");
        }
      })
      .catch((err) => {
        dispatch(
          updateAlert({
            severity: "error",
            text: err,
            open: true,
          })
        );
      });
  };
};

export const getInsuranceOffer = (body) => {
  return async (dispatch) => {
    return await callService("getInsuranceOffer", body, dispatch, body.externalId)
      .then((response) => {
        const data = response.data;
        if (data.guarantorList?.length > 0 || data.totalAmount) {
          data.insuranceOfferCreated = true;
          data.guarantorList = data.guarantorList?.map((row, id) => {
            return {
              id,
              ...row,
            };
          });
          dispatch(updateLimitAndPaymentInfo({ insuranceOffer: data }));
          dispatch(
            addProcessContext({
              insurancePrice: data.totalAmount,
            })
          );

          return data;
          
        } else {
          //throw data;
        }
      })
      .catch((err) => {
        let errText = "";
        if (err.errorExplanation) {
          errText = err.errorExplanation;
        } else if (err.errorText) {
          errText = err.errorText;
        }

        dispatch(
          updateAlert({
            severity: "error",
            text: errText,
            open: true,
          })
        );
      });
  };
};

export const getTarifeOffer = (body) => {
  return async (dispatch) => {
    return await callService("commissionPackOffer", body, dispatch, body.externalId)
      .then((response) => {
        const data = response.data;
        if (
          data.result === "1" &&
          data.commissionPackName &&
          data.commissionPackName !== ""
        ) {
          data.tarifeOfferCreated = true;
          dispatch(updateLimitAndPaymentInfo({ tarifeOffer: data }));
          dispatch(
            addProcessContext({
              tarifeePrice: data.commissionPackPrice,
            })
          );
        } else {
          //throw data;
        }
      })
      .catch((err) => {
        let errText = "";
        if (err.errorExplanation) {
          errText = err.errorExplanation;
        } else if (err.errorText) {
          errText = err.errorText;
        }

        dispatch(
          updateAlert({
            severity: "error",
            text: errText,
            open: true,
          })
        );
      });
  };
};

export const getLimitDetails = (body, history) => {
  return async (dispatch) => {
    return await callService("getCustLimitInfo", body, dispatch, body.externalId)
      .then((response) => {
        console.log(response)
        const data = response.data;
        if (data.result === "1") {
          return {...response};
        } else {
          throw data;
        }
      })
      .catch((err) => {
        let errText = "";
        if (err.errorExplanation) {
          errText = err.errorExplanation;
        } else if (err.errorText) {
          errText = err.errorText;
        }
        // Handle the unauthorized error
        if (err.status === 401 || err.code === "UNAUTHORIZED") {
          history.push("/unauthorized"); // Redirect to the unauthorized page
        }
        dispatch(
          updateAlert({
            severity: "error",
            text: errText,
            open: true,
          })
        );
      });
  };
};
